import { Box, Button, Typography } from "@mui/material";
import useGrantApplicationForm from "../../hooks/application/useGrantApplicationForm";
import PageContainer from "../../components/custom/layout/pageContainer";
import PageHeader from "../../components/custom/layout/pageHeader";
import StepsBar from "../../components/custom/ui/stepsBar";
import Step1Form from "../../components/custom/steps/step1Form";
import Step2Form from "../../components/custom/steps/step2Form";
import Step3Form from "../../components/custom/steps/step3Form";
import Step4Form from "../../components/custom/steps/step4Form";
import Step5Done from "../../components/custom/steps/step5Done";
import {PAGE_APPLICATIONS} from "../../locales/pages/namespaces";
import {useTranslation} from "react-i18next";
import {useParams} from "react-router-dom";
import {LoadingButton} from "@mui/lab";


const normalizeError = (err) => {
	if (!err) return "";
	if (typeof err === "string") return err;
	if (err.message && typeof err.message === "string") return err.message;
	if (err.message && err.message.message) return err.message.message;
	if (err.error) return err.error;

	try {
		return JSON.stringify(err);
	} catch {
		return "Unexpected error";
	}
};

const NewApplication = () => {
	const {campaign} = useParams()
	const {
		formik,
		activeStep,
		completed,
		handleNext,
		handleBack,
		countries,
		counties,
		currencies,
		organization,
		loading,
		error,
		handleCountyChange,
		requestNumber,
		showSuccessModal,
		setShowSuccessModal,
		language,
	} = useGrantApplicationForm(5,campaign);
	const safeCounties = Array.isArray(counties) ? counties : (counties ? [counties] : []);
	const isLastStep = activeStep === 4;
	const {t} = useTranslation(PAGE_APPLICATIONS)
	const stepsLabels = [
		t("Tax Identification Number"),
		t("Organization details"),
		t("Representative"),
		t("Request details"),
		t("Done"),
	];
	const titles = [
		{ id: "Mr", NameEN: "Mr",NameEL:"Κος" },
		{ id: "Mrs", NameEN: "Mrs",NameEL:"Κα" },
		{ id: "Other", NameEN: "Other",NameEL:"Άλλο" }
	];
	return (
		<PageContainer>
			<PageHeader />

			<Typography sx={{ mt: 6, mb: 2, fontWeight: 700, fontSize: 24 }}>
				{t("SNF Grant portal")}
				<br />
				{t("Organization and request details")}
			</Typography>

			<StepsBar steps={stepsLabels} active={activeStep} completed={completed} />

			<form
				onSubmit={(e) => {
					e.preventDefault();
					if (!isLastStep) {
						handleNext();
					}
				}}
			>
				{activeStep === 0 &&
					<Step1Form
					formik={formik}
					loading={loading && activeStep === 0}
					error={normalizeError(error)}
					/>
				}
				{activeStep === 1 &&
					<Step2Form
						formik={formik}
						countries={countries}
						counties={safeCounties}
						organization={organization}
						handleCountyChange={handleCountyChange}
						language={language}
						error={normalizeError(error)}
					/>
				}
				{activeStep === 2 &&
					<Step3Form
						formik={formik}
						counties={counties}
						language={language}
						error={normalizeError(error)}
						titles={titles}
					/>
				}
				{activeStep === 3 &&
					<Step4Form
						formik={formik}
						currencies={currencies}
						language={language}
						error={normalizeError(error)}
					/>
				}
				{activeStep === 4 && (
					<Step5Done
						requestNumber={requestNumber}
						showSuccessModal={showSuccessModal}
						setShowSuccessModal={setShowSuccessModal}
					/>
				)}

				{activeStep < 4 && (
					<Box sx={{ mt: 6, display: "flex", gap: 2 }}>
						{activeStep === 3 && (
							<Button
								variant="contained"
								sx={{ bgcolor: "#004B88",color:"#fff",mr: 2 }}
								onClick={() => formik.resetForm()}
							>
								{t("Reset")}
							</Button>
						)}

						<Button
							variant="contained"
							sx={{ bgcolor: "#004B88",color:"#fff" }}
							onClick={handleBack}
							disabled={loading}
						>
							{t("Back")}
						</Button>

						<LoadingButton
							type="submit"
							variant="contained"
							loading={activeStep === 0 && loading}
							disabled={activeStep === 0 && loading}
							sx={{ bgcolor: "#004B88", color: "#fff" }}
						>
							{activeStep === 3 ? t("Submit") : t("Next")}
						</LoadingButton>
					</Box>
				)}
			</form>
		</PageContainer>
	);
};

export default NewApplication;
